/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationCompanyDepartmentsQuery = gql`
  query GetSimulationCompanyDepartmentsQuery {
    getSimulationCompanyDepartments_simulation_company {
      departments {
 value  
label  
}
    }
  }
`;

export default GetSimulationCompanyDepartmentsQuery;
